export default "__VITE_ASSET__BcSBrBoq__"